exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".formCard[data-v-a97c99c2]{border:none!important;padding:0}.tab-list[data-v-a97c99c2]{display:flex;cursor:pointer;overflow-x:auto}.tab-list div[data-v-a97c99c2]{padding:5px;margin:5px;border:1px solid #ccc;border-radius:5px;white-space:nowrap;user-select:none;transition:background-color .3s}.tab-list div[data-v-a97c99c2]:hover{background-color:#0aa46e}.active-tab[data-v-a97c99c2]{background-color:#007bff;color:#fff}.fade-enter-active[data-v-a97c99c2],.fade-leave-active[data-v-a97c99c2]{transition:opacity .5s}.fade-enter[data-v-a97c99c2],.fade-leave-to[data-v-a97c99c2]{opacity:0}.custom-slide-enter-active[data-v-a97c99c2],.custom-slide-leave-active[data-v-a97c99c2]{transition:transform .5s}.custom-slide-enter[data-v-a97c99c2],.custom-slide-leave-to[data-v-a97c99c2]{transform:translateX(100%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a97c99c2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/portExpenseModule/Tab.vue
// module id = 1774
// module chunks = 0